export default "__VITE_ASSET__DV8zbH8z__"